import { render, staticRenderFns } from "./StaffWorkload.vue?vue&type=template&id=212074f8&scoped=true&"
import script from "./StaffWorkload.vue?vue&type=script&lang=js&"
export * from "./StaffWorkload.vue?vue&type=script&lang=js&"
import style0 from "./StaffWorkload.vue?vue&type=style&index=0&id=212074f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212074f8",
  null
  
)

export default component.exports